module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/bg_preintro-d125e403a28f4b1856269b48c5ce35f0.jpg";